
//Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

//routing
import { store } from '../../../store/configure';
import { setLandingPage } from '../../../actions/actions';

//Calendar
import { esFeriado, esDiaDeSemana } from '../Utils/CalendarUtils';

//material-ui
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';


const styles = theme => ({
  root: {
    flexGrow: 1
  },
  leyenda: {
    margin: '3em auto',
    fontSize: '1.4em'
  },
  fab: {
    marginTop: '-1.8em',
    width: '17%',
    color: '#fff',
    backgroundColor: '#f47321',
    boxShadow: "none",
    '&:hover':{
      color: '#fff',
      backgroundColor: '#fa9c5f'
    },
    '&:disabled':{
      color: '#fff',
      backgroundColor: '#bbbbbb'
    },
  },
  '@media  screen and (max-width: 700px)': {
    fab: {
      width: '15em'
    }
  }
});

class ContainerBtn extends Component {
    constructor(props){
      super(props);
      this.avanzar = this.avanzar.bind(this);
    }

    avanzar(){
      this.props.history.push('/plazo-fijo/PF-info-basica');
    }

    render() {
        const {classes} = this.props;
        const horarioActual = moment();
        const horarioMinimo = moment('7:00am', 'h:mma');
        const horarioMaximo = moment('16:30pm', 'h:mma');
        const formato=this.props.dataFeriados.formatoFecha;
        const dias=this.props.dataFeriados.listaFeriados;
        
        return (
            <div className="container-btn">
                <Grid container>
                    <Grid item xs={12}>
                        <Fab
                          className={classes.fab}
                          disabled={horarioActual.isAfter(horarioMaximo) || horarioActual.isBefore(horarioMinimo) || !esDiaDeSemana() || esFeriado(formato,dias)}
                          variant="extended"
                          onClick={this.avanzar}>
                                Crear plazo fijo
                        </Fab>
                    </Grid>
                    { horarioActual.isAfter(horarioMaximo) || horarioActual.isBefore(horarioMinimo) || !esDiaDeSemana() || esFeriado(formato,dias)  ?
                      <p className={classes.leyenda}>Para constituir tu Plazo Fijo online, ingresá días hábiles de 7 a 16:30 hs. </p>
                       : null
                    }
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(ContainerBtn);


// WEBPACK FOOTER //
// ./src/components/PlazoFijo/landingPage/ContainerBtn.js